import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setAttemptsError } from '../../../redux/demo-recreate/demoRecreateReducer';
import NoAttemptsModal from './NoAttemptsModal';

function NoAttemptsErrorController() {
  const dispatch = useDispatch();
  const attemptsError = useSelector((state) => state.demoRecreate.attemptsError);

  const handleClose = () => {
    dispatch(setAttemptsError(false));
  };

  return <NoAttemptsModal isOpen={attemptsError} onClose={handleClose} />;
}

export default NoAttemptsErrorController;
